export interface OktaUser {
  sub: string;
  email?: string;
  isUserAdmin?: boolean;
  name?: string;
  locale?: string;
  preferred_username?: string;
  given_name?: string;
  family_name?: string;
  zoneinfo?: string;
  updated_at?: number;
  email_verified?: boolean;
}

export interface User {
  id: number;
  username: string;
  userPreferences: UserPreference[];
}

export enum USER_PREFERENCE_KEY {
  UPK_REPORT_VISIBLE_COLUMNS = 'UPK_REPORT_VISIBLE_COLUMNS',
  UPK_REPORT_ADVANCED_FILTER = 'UPK_REPORT_ADVANCED_FILTER'
}

export interface UserPreference {
  id: number;
  userPreferenceKey: USER_PREFERENCE_KEY;
  value: string;
}
